if (!window.__ldzUpsell) {
    window.__ldzUpsell = true;
    const ldzRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.ldz-upsell__btn');
      if (!button) return;
      const box = button.closest('.ldz-upsell');
      const select = box.querySelector('select');
      const id = (select && select.value) || box.dataset.defaultVariant;
      button.disabled = true;
      button.textContent = 'Añadiendo…';
      try {
        const carts = [...document.querySelectorAll('cart-items-component[data-section-id]')];
        const sectionIds = carts.map((el) => el.dataset.sectionId);
        const response = await fetch(ldzRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(','), sections_url: window.location.pathname }),
        });
        if (!response.ok) throw new Error('add failed');
        const data = await response.json();
        const { morphSection } = await import('@theme/section-renderer');
        for (const el of carts) {
          const html = data.sections && data.sections[el.dataset.sectionId];
          if (html) await morphSection(el.dataset.sectionId, html, { mode: el.hasAttribute('data-drawer') ? 'hydration' : 'full' });
        }
        const cart = await (await fetch(ldzRoot + 'cart.js')).json();
        document.querySelectorAll('.cart-bubble__text-count').forEach((el) => { el.textContent = cart.item_count; el.classList.remove('hidden'); });
        document.querySelectorAll('.cart-bubble').forEach((el) => el.classList.remove('visually-hidden'));
      } catch (error) {
        window.location.reload();
      }
    });
  }
